import React from 'react';
import OptionCalendarComponent from './OptionCalendarComponent.tsx';
import { Outlet } from 'react-router-dom';

function HistoryLayoutComponent() {

    return (
        <>
            <div className="text-center mt-lg-2">
                <OptionCalendarComponent />
            </div>
            <div>
                <Outlet />
            </div>
        </>
    )
}
export default HistoryLayoutComponent;